// extracted by mini-css-extract-plugin
export default {"acceptButton":"SetupButton_acceptButton__tq9vf","disabledButton":"SetupButton_disabledButton__tDNh-"};